import React, { useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import 'bootstrap/dist/css/bootstrap.min.css';
import { UserPermisos } from "../model/UserPermisos";
import { checkUser } from "../dao/checkUser";
import { AuthContext } from '../config/AuthContext';
import { Button, Layout, message } from "antd";
import { Content } from "antd/es/layout/layout";
import AppFooter from "./components/AppFooter";
import AvaluacioColors from "../styles/AvaluacioColors";
import { GetAlumneId } from "../dao/GetAlumneId";
import { DefaultAulumneInfo } from "../model/AlumneInfo";
import { GoogleLogin } from '@react-oauth/google';
import { Modal } from "antd";

interface LoginProps {
    isJutge?: boolean;
}

const Login: React.FC<LoginProps> = ({ isJutge: propIsJutge }) => {
    const isJutge = propIsJutge !== undefined ? propIsJutge : (typeof window !== 'undefined' && window.location.pathname.startsWith('/jutge'));
    const [usuari, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [usuaripermisos, setUsuaripermisos] = useState<UserPermisos>();
    const [showContainer, setShowContainer] = useState(false);

    // Modal de confirmació per crear un usuari nou de Google
    const [googleModalOpen, setGoogleModalOpen] = useState(false);
    const [pendingGoogle, setPendingGoogle] = useState<{ token: string; email: string; nom: string; cognoms: string } | null>(null);

    const { setLoggedIn, setUserId, setUser, setAlumneInfo, setUserPermisos } = useContext(AuthContext);
    const navigate = useNavigate();

    // Mostrar el container con animación después de 1.5s
    useEffect(() => {
        const timer = setTimeout(() => setShowContainer(true), 1500);
        return () => clearTimeout(timer);
    }, []);

    const handleUsernameChange = (event: React.ChangeEvent<HTMLInputElement>) => setUsername(event.target.value);
    const handlePasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => setPassword(event.target.value);

    const [mode, setMode] = useState<'initial' | 'login' | 'register' | 'recover'>('initial');
    const [regEmail, setRegEmail] = useState('');
    const [regPassword, setRegPassword] = useState('');
    const [regNom, setRegNom] = useState('');
    const [regCognoms, setRegCognoms] = useState('');
    const [recEmail, setRecEmail] = useState('');

    const handleRegister = async () => {
        setLoading(true);
        if (!regEmail || !regPassword || !regNom || !regCognoms) {
            message.error("Todos los campos son obligatorios");
            setLoading(false);
            return;
        }

        const firstLetter = regNom.trim().charAt(0).toLowerCase();
        const firstSurname = regCognoms.trim().split(' ')[0].toLowerCase();
        const generatedUsername = (firstLetter + firstSurname)
            .normalize("NFD").replace(/[\u0300-\u036f]/g, "");

        try {
            const apiUrl = process.env.REACT_APP_API_URL;
            const res = await fetch(`${apiUrl}:8061/login/register`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    usuari: generatedUsername,
                    password: regPassword,
                    email: regEmail,
                    nom: regNom,
                    cognoms: regCognoms,
                    ...(isJutge ? { rol: '3', isJutge: true } : {})
                })
            });
            if (res.ok) {
                message.success(`Usuario registrado correctamente: ${generatedUsername}. Ahora puedes iniciar sesión.`);
                setMode('login');
            } else {
                const text = await res.text();
                message.error(text || "Error al registrar");
            }
        } catch (e) {
            message.error("Error de conexión");
        } finally {
            setLoading(false);
        }
    };

    const handleRecover = async () => {
        setLoading(true);
        try {
            const apiUrl = process.env.REACT_APP_API_URL;
            const res = await fetch(`${apiUrl}:8061/login/recover`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email: recEmail })
            });
            if (res.ok) {
                message.success("Si el email existe, recibirás una nueva contraseña.");
                setMode('login');
            } else {
                const text = await res.text();
                message.error(text || "Error al recuperar");
            }
        } catch (e) {
            message.error("Error de conexión");
        } finally {
            setLoading(false);
        }
    };

    const check = async (usuari: string, password: string) => {
        setLoading(true);
        const usuariP = await checkUser(usuari, password);
        // Note: usuariP now contains { token, permisos } if successful
        // We need to handle the case where it's not ERROR carefully before accessing properties
        let alu = DefaultAulumneInfo; // Default fallback
        if (usuariP !== 'ERROR' && usuariP.permisos && usuariP.permisos.length > 0) {
            const res = await GetAlumneId(usuariP.permisos[0].id, usuariP.token);
            if (res) alu = res;
        }

        if (usuariP !== 'ERROR') {
            const { token, permisos } = usuariP;
            localStorage.setItem('authToken', token);

            setUsuaripermisos(permisos);
            setLoggedIn(true);
            setUserId(String(permisos[0].id));
            setUser(permisos[0]);
            setUserPermisos(permisos);
            setAlumneInfo(alu);

            //if (!alu.alumne.nom) navigate('/username');
            //else if (window.location.pathname.match(/^\/jutge\/activitats\/\d+\/problemes\/\d+$/)) {
            //navigate(window.location.pathname);
            //}
            if (window.location.pathname.match(/^\/home\/aules\/\d+\/projectes\/\d+$/)) {
                navigate(window.location.pathname);
            } else if (window.location.pathname.match(/^\/jutge\/practiques\/\d+$/)) {
                navigate(window.location.pathname);
            } else if (window.location.pathname.match(/^\/jutge\/activitats\/\d+$/)) {
                navigate(window.location.pathname);
            } else if (
                window.location.pathname.match(/^\/home\/cua$/) ||
                window.location.pathname.match(/^\/home\/dubte$/)
            ) {
                navigate(window.location.pathname);
            }
            else navigate('/home');
        } else {
            message.error("Usuari o contrasenya incorrectes");
        }
        setLoading(false);
    };

    const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || "263998953995-lj8b0d0q5boof4j70jrtlch4rvjtulqi.apps.googleusercontent.com";

    // Processa una resposta d'inici de sessió correcta (login normal o Google)
    const processLoginSuccess = async (usuariP: any) => {
        let alu = DefaultAulumneInfo;
        if (usuariP && usuariP.permisos && usuariP.permisos.length > 0) {
            const aluRes = await GetAlumneId(usuariP.permisos[0].id, usuariP.token);
            if (aluRes) alu = aluRes;
        }

        const { token, permisos } = usuariP;
        localStorage.setItem('authToken', token);

        setUsuaripermisos(permisos);
        setLoggedIn(true);
        setUserId(String(permisos[0].id));
        setUser(permisos[0]);
        setUserPermisos(permisos);
        setAlumneInfo(alu);

        const isRole3 = permisos && permisos.length > 0 && (permisos[0].tipus === "3" || permisos[0].tipus === 3);

        if (isRole3) {
            navigate('/jutge/problemes');
        } else if (isJutge) {
            navigate('/jutge/problemes');
        } else if (window.location.pathname.match(/^\/home\/aules\/\d+\/projectes\/\d+$/)) {
            navigate(window.location.pathname);
        } else if (window.location.pathname.match(/^\/jutge\/practiques\/\d+$/)) {
            navigate(window.location.pathname);
        } else if (window.location.pathname.match(/^\/jutge\/activitats\/\d+$/)) {
            navigate(window.location.pathname);
        } else if (
            window.location.pathname.match(/^\/home\/cua$/) ||
            window.location.pathname.match(/^\/home\/dubte$/)
        ) {
            navigate(window.location.pathname);
        }
        else navigate('/home');
    };

    const handleGoogleLogin = async (credentialResponse: any) => {
        setLoading(true);
        try {
            const apiUrl = process.env.REACT_APP_API_URL;
            const res = await fetch(`${apiUrl}:8061/login/google`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    token: credentialResponse.credential,
                    clientId: GOOGLE_CLIENT_ID
                })
            });
            if (res.ok) {
                const usuariP = await res.json();
                // L'usuari no existeix → demanem confirmació abans de crear-lo
                if (usuariP && usuariP.exists === false) {
                    setPendingGoogle({
                        token: credentialResponse.credential,
                        email: usuariP.email,
                        nom: usuariP.nom,
                        cognoms: usuariP.cognoms
                    });
                    setGoogleModalOpen(true);
                    return;
                }
                await processLoginSuccess(usuariP);
            } else {
                const text = await res.text();
                message.error(text || "Error al iniciar sesión con Google");
            }
        } catch (e) {
            message.error("Error de conexión");
        } finally {
            setLoading(false);
        }
    };

    // Confirma la creació de l'usuari de Google (des del modal)
    const confirmGoogleCreate = async () => {
        if (!pendingGoogle) return;
        setLoading(true);
        try {
            const apiUrl = process.env.REACT_APP_API_URL;
            const res = await fetch(`${apiUrl}:8061/login/google/create`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    token: pendingGoogle.token,
                    clientId: GOOGLE_CLIENT_ID
                })
            });
            if (res.ok) {
                const usuariP = await res.json();
                setGoogleModalOpen(false);
                setPendingGoogle(null);
                await processLoginSuccess(usuariP);
            } else {
                const text = await res.text();
                message.error(text || "Error al crear el usuario con Google");
            }
        } catch (e) {
            message.error("Error de conexión");
        } finally {
            setLoading(false);
        }
    };

    const cancelGoogleCreate = () => {
        setGoogleModalOpen(false);
        setPendingGoogle(null);
    };

    // 🎨 Estilos inline
    const styles = {
        background: {
            position: "fixed" as const,
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundImage: "url('/images/Lanterns.png')",
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            filter: "blur(8px) brightness(0.75)",
            zIndex: 0,
        },
        container: {
            width: "320px",
            margin: "0 auto",
            padding: "40px",
            marginTop: "15%",
            background: "rgba(255, 255, 255, 0.85)",
            borderRadius: "12px",
            boxShadow: "0 4px 30px rgba(0,0,0,0.1)",
            position: "relative" as const,
            zIndex: 2,
            backdropFilter: "blur(6px)",
            textAlign: "center" as const,
        },
        title: {
            marginBottom: "24px",
            color: "#333",
            fontWeight: 600,
            fontSize: "1.5rem",
        },
        label: {
            display: "block",
            marginBottom: "6px",
            fontWeight: 500,
            textAlign: "left" as const,
        },
        input: {
            width: "100%",
            padding: "8px",
            fontSize: "14px",
            borderRadius: "4px",
            border: "1px solid #ccc",
            marginBottom: "16px",
        },
    };

    return (
        <Layout style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', position: 'relative', zIndex: 1 }}>
            {/* 🌌 Fondo difuminado */}
            <div style={styles.background}></div>

            <Content style={{ padding: '0 48px', flex: '1 0 auto' }}>
                <Layout style={{ padding: '24px 0', background: 'transparent', borderRadius: '8px' }}>
                    {/* Contenedor animado */}
                    <div
                        style={{
                            ...styles.container,
                            opacity: showContainer ? 1 : 0,
                            transform: showContainer ? "translateY(0)" : "translateY(20px)",
                            transition: "opacity 0.8s ease, transform 0.8s ease",
                        }}
                    >
                        {mode === 'initial' && (
                            <>
                                <h2 style={styles.title}>Bienvenido</h2>
                                
                                <div style={{ marginTop: 20, display: "flex", justifyContent: "center" }}>
                                    <GoogleLogin
                                        onSuccess={handleGoogleLogin}
                                        onError={() => {
                                            message.error('Ocurrió un error al intentar iniciar sesión con Google');
                                        }}
                                        theme="outline"
                                        size="large"
                                        width={240}
                                        text="continue_with"
                                    />
                                </div>

                                <div style={{ display: 'flex', alignItems: 'center', margin: '20px 0' }}>
                                    <div style={{ flex: 1, height: '1px', backgroundColor: '#ccc' }}></div>
                                    <span style={{ margin: '0 10px', color: '#666', fontSize: 13 }}>O</span>
                                    <div style={{ flex: 1, height: '1px', backgroundColor: '#ccc' }}></div>
                                </div>

                                <Button
                                    style={{
                                        width: "100%",
                                        backgroundColor: "transparent",
                                        border: `1px solid ${AvaluacioColors.colors.color6}`,
                                        color: AvaluacioColors.colors.color6,
                                        fontWeight: 500,
                                    }}
                                    onClick={() => setMode('login')}
                                >
                                    Continuar amb Correu
                                </Button>

                                <div style={{ marginTop: 20, fontSize: 13, display: 'flex', flexDirection: 'column', gap: 5 }}>
                                    <span>¿No tienes cuenta? <a style={{ cursor: 'pointer', color: AvaluacioColors.colors.color6, fontWeight: 'bold' }} onClick={() => setMode('register')}>Regístrate</a></span>
                                </div>
                            </>
                        )}

                        {mode === 'login' && (
                            <>
                                <h2 style={styles.title}>Iniciar sesión amb Correu</h2>

                                <div className="form-group">
                                    <label htmlFor="username" style={styles.label}>Usuario:</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="username"
                                        value={usuari}
                                        style={styles.input}
                                        onChange={handleUsernameChange}
                                        onKeyDown={(e) => e.key === "Enter" && check(usuari, password)}
                                    />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="password" style={styles.label}>Contraseña:</label>
                                    <input
                                        type="password"
                                        className="form-control"
                                        id="password"
                                        value={password}
                                        style={styles.input}
                                        onChange={handlePasswordChange}
                                        onKeyDown={(e) => e.key === "Enter" && check(usuari, password)}
                                    />
                                </div>

                                <Button
                                    loading={loading}
                                    style={{
                                        width: "100%",
                                        backgroundColor: AvaluacioColors.colors.color6,
                                        border: "none",
                                        color: "white",
                                        fontWeight: 500,
                                        marginTop: 10
                                    }}
                                    disabled={loading}
                                    onClick={() => check(usuari, password)}
                                >
                                    Iniciar sesión
                                </Button>
                                
                                <div style={{ marginTop: 20, fontSize: 13, display: 'flex', flexDirection: 'column', gap: 5 }}>
                                    <a style={{ cursor: 'pointer', color: '#666' }} onClick={() => setMode('recover')}>¿Has olvidado tu contraseña?</a>

                                    <a style={{ cursor: 'pointer', color: AvaluacioColors.colors.color6, fontWeight: 'bold', marginTop: 10 }} onClick={() => setMode('initial')}>Volver atrás</a>
                                </div>
                            </>
                        )}

                        {mode === 'register' && (
                            <>
                                <h2 style={styles.title}>Registrarse</h2>


                                <div className="form-group">
                                    <label style={styles.label}>Email:</label>
                                    <input type="email" className="form-control" style={styles.input} value={regEmail} onChange={(e) => setRegEmail(e.target.value)} />
                                </div>
                                <div style={{ display: 'flex', gap: 10 }}>
                                    <div className="form-group" style={{ flex: 1 }}>
                                        <label style={styles.label}>Nombre:</label>
                                        <input type="text" className="form-control" style={styles.input} value={regNom} onChange={(e) => setRegNom(e.target.value)} />
                                    </div>
                                    <div className="form-group" style={{ flex: 1 }}>
                                        <label style={styles.label}>Apellidos:</label>
                                        <input type="text" className="form-control" style={styles.input} value={regCognoms} onChange={(e) => setRegCognoms(e.target.value)} />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label style={styles.label}>Contraseña:</label>
                                    <input type="password" className="form-control" style={styles.input} value={regPassword} onChange={(e) => setRegPassword(e.target.value)} />
                                    <small style={{ display: 'block', textAlign: 'left', color: '#999', fontSize: 11, marginTop: -10, marginBottom: 10 }}>Mín 8 carácteres, 1 mayúscula, 1 número.</small>
                                </div>

                                <Button loading={loading} style={{ width: "100%", backgroundColor: AvaluacioColors.colors.color5, border: "none", color: "white", fontWeight: 500 }} onClick={handleRegister}>
                                    Crear Cuenta
                                </Button>
                                <div style={{ marginTop: 15, fontSize: 13 }}>
                                    <a style={{ cursor: 'pointer', color: '#666' }} onClick={() => setMode('initial')}>Volver atrás</a>
                                </div>
                            </>
                        )}

                        {mode === 'recover' && (
                            <>
                                <h2 style={styles.title}>Recuperar Contraseña</h2>
                                <p style={{ fontSize: 13, color: '#666', marginBottom: 20 }}>Introduce tu email y te enviaremos una nueva contraseña.</p>

                                <div className="form-group">
                                    <label style={styles.label}>Email:</label>
                                    <input type="email" className="form-control" style={styles.input} value={recEmail} onChange={(e) => setRecEmail(e.target.value)} />
                                </div>

                                <Button loading={loading} style={{ width: "100%", backgroundColor: AvaluacioColors.colors.color4, border: "none", color: "white", fontWeight: 500 }} onClick={handleRecover}>
                                    Enviar Email
                                </Button>
                                <div style={{ marginTop: 15, fontSize: 13 }}>
                                    <a style={{ cursor: 'pointer', color: '#666' }} onClick={() => setMode('login')}>Volver atrás</a>
                                </div>
                            </>
                        )}
                    </div>
                </Layout>
            </Content>

            <AppFooter />

            {/* Modal de confirmació: crear usuari nou de Google */}
            <Modal
                open={googleModalOpen}
                title="Usuario no encontrado"
                okText="Crear cuenta"
                cancelText="Cancelar"
                confirmLoading={loading}
                onOk={confirmGoogleCreate}
                onCancel={cancelGoogleCreate}
            >
                <p>No hemos encontrado ninguna cuenta asociada a este correo de Google. ¿Quieres crear un usuario nuevo con estos datos?</p>
                {pendingGoogle && (
                    <div style={{ marginTop: 12, lineHeight: 1.8 }}>
                        <div><b>Nombre:</b> {`${pendingGoogle.nom} ${pendingGoogle.cognoms}`.trim() || '—'}</div>
                        <div><b>Correo:</b> {pendingGoogle.email}</div>
                    </div>
                )}
                <p style={{ marginTop: 12, color: '#999', fontSize: 12 }}>
                    Si has iniciado sesión con un correo equivocado, pulsa Cancelar.
                </p>
            </Modal>
        </Layout>
    );
};

export default Login;
